(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('wsCardHeader', ['Card', 'CardGroup', 'CardDisplay', 'User', 'UserRoles', 'CardUtils', '$rootScope', 'wsEventNames', '$timeout', function (Card, CardGroup, CardDisplay, User, UserRoles, CardUtils, $rootScope, wsEventNames, $timeout) {
    return {
      templateUrl: "modules/common/directives/card-header/card-header.html",
      scope: {
        card: "=?",
        cardTemplate: "=?",
        headerText: "=?",
        cardManagementEnabled: "=?",
        detailsUrl: '@?'
      },
      link: function link(scope, element) {
        if (scope.cardManagementEnabled === undefined || scope.cardManagementEnabled === null) {
          scope.cardManagementEnabled = true;
        }
        if (!CardDisplay.cardGroup || !scope.card || scope.card.id === 'preview') {
          scope.cardManagementEnabled = false;
        } else if (!CardDisplay.cardGroup.user && !UserRoles.isOrgManager(User.get())) {
          scope.cardManagementEnabled = false;
        }
        if (scope.card && scope.card.id === 'preview') {
          $rootScope.$on(wsEventNames.explorer.change.cardTitle, function (evt, title) {
            scope.headerText = title;
          });
        }

        // Remember if this is a card group card
        scope.isCardGroupCard = scope.card && CardDisplay._isGroupCard(scope.card);
        scope.detailsUrl = scope.detailsUrl || scope.card && CardUtils.getCardUrl(scope.card);
        if (scope.isCardGroupCard) {
          var title = element.find(".title"),
            title_edit = title.children(".title-edit").eq(0),
            header = title.children("a").eq(0),
            input = title_edit.children("input").eq(0),
            previousTitle = scope.card.title;

          // Start editing mode when they click the card title
          $rootScope.$on(wsEventNames.card.rename + scope.card.id, function () {
            // $timeout is necessary since we're now building a new card with react-grid
            // instead of just using an existing card, like we did with packery. This gives
            // the directive a moment to compile before trying to select the header.
            $timeout(function () {
              header.hide();
              title_edit.show();
              input.show().focus().select();
            }, 100);
          });

          // End editing mode when they click away
          input.blur(function () {
            header.show();
            title_edit.hide();
            input.hide();
            if (scope.card.title !== previousTitle) {
              previousTitle = scope.card.title;
              Card.save(scope.card);
            }
          });

          // Also end editing mode when they hit enter
          input.keyup(function (evt) {
            if (evt.keyCode === 13) {
              input.blur();
              title_edit.hide();
            }
          });
        }
      }
    };
  }]);
})();
